import { useTranslation } from 'react-i18next';
// ... existing code ...

export default function TradingExample() {
  const { t } = useTranslation();
  // ... existing code ...

  return (
    <section id="trading-example" className="py-24 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #0c0814 0%, #100b1e 100%)' }}>
      <div className="absolute inset-0 grid-bg pointer-events-none opacity-50" />
      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-10 md:mb-16">
          <div className="badge-purple mx-auto mb-6" style={{ display: 'inline-flex' }}>{t('tradingExample.badge')}</div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-5 font-display" style={{ letterSpacing: '-0.03em', lineHeight: '1.08' }}>
            &nbsp; &nbsp;{t('tradingExample.title1')}
            <span className="text-gradient-aurora">&nbsp; &nbsp; &nbsp; &nbsp; {t('tradingExample.title2')}</span>
          </h2>
          <p className="text-lg text-white/45 max-w-3xl mx-auto">{t('tradingExample.desc')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8 mb-10 md:mb-16">
          {/* Stage 1 */}
          <div className="premium-card premium-card-hover rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-purple-400/12 border border-purple-400/22 flex items-center justify-center">
                <i className="ri-line-chart-line text-2xl text-purple-400"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-white font-heading">{t('tradingExample.s1_title')}</h3>
                <p className="text-sm text-purple-400">{t('tradingExample.s1_sub')}</p>
              </div>
            </div>
            <div className="flex items-center gap-2 bg-amber-400/8 border border-amber-400/20 rounded-lg px-3 py-2 mb-4">
              <i className="ri-information-line text-amber-400 text-sm"></i>
              <span className="text-xs text-amber-400 font-medium">{t('tradingExample.s1_notice')}</span>
            </div>
            <div className="space-y-4 mb-6">
              <div className="bg-purple-400/5 border border-purple-400/12 rounded-xl p-4">
                <div className="text-sm text-white/40 mb-1">{t('tradingExample.s1_price')}</div>
                <div className="flex items-end gap-2">
                  <div className="text-3xl font-bold text-white">$68,500</div>
                  <span className="text-xs text-amber-400 bg-amber-400/8 border border-amber-400/20 rounded-full px-2 py-0.5 mb-1 whitespace-nowrap">{t('tradingExample.s1_eg')}</span>
                </div>
              </div>
              <div className="space-y-3">
                {[
                  { labelKey: 'tradingExample.s1_priceVol', val: '+150 USD', valColor: 'text-purple-400' },
                  { labelKey: 'tradingExample.s1_vol', val: 'High', valColor: 'text-white' },
                  { labelKey: 'tradingExample.s1_depth', val: 'Normal', valColor: 'text-white' },
                ].map(row => (
                  <div key={row.labelKey} className="flex items-center justify-between text-sm bg-white/[0.03] border border-purple-500/8 rounded-lg px-3 py-2.5">
                    <span className="text-white/40">{t(row.labelKey)}</span>
                    <div className="flex items-center gap-2">
                      <span className={`${row.valColor} font-bold`}>{row.val}</span>
                      <span className="text-xs text-amber-400 bg-amber-400/8 border border-amber-400/20 rounded-full px-1.5 py-0.5 whitespace-nowrap">{t('tradingExample.s1_eg')}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="border border-purple-400/18 rounded-xl p-3 flex items-center gap-2" style={{ background: 'rgba(147,51,234,0.07)' }}>
              <i className="ri-checkbox-circle-fill text-purple-400 text-sm"></i>
              <span className="text-sm text-purple-300 font-medium">{t('tradingExample.s1_trigger')}</span>
              <span className="ml-auto text-xs text-purple-400 bg-purple-400/8 border border-purple-400/18 rounded-full px-2 py-0.5 whitespace-nowrap">{t('tradingExample.s1_met')}</span>
            </div>
          </div>

          {/* Stage 2 */}
          <div className="rounded-2xl p-8 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #1a0840, #0f1840)', border: '1px solid rgba(168,85,247,0.25)' }}>
            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-xl bg-purple-400/15 border border-purple-400/25 flex items-center justify-center">
                  <i className="ri-brain-line text-2xl text-purple-400"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white font-heading">{t('tradingExample.s2_title')}</h3>
                  <p className="text-sm text-purple-400">{t('tradingExample.s2_sub')}</p>
                </div>
              </div>
              <div className="space-y-4 mb-6">
                <div className="bg-white/[0.04] rounded-xl p-4 border border-white/8">
                  <div className="text-sm text-white/50 mb-2">{t('tradingExample.s2_marketImplied')}</div>
                  <div className="flex justify-between text-xs text-white/50 mb-1"><span>{t('tradingExample.s2_yes')}</span><span>42%</span></div>
                  <div className="h-2 bg-white/8 rounded-full overflow-hidden"><div className="h-full bg-white/25 rounded-full" style={{width: '42%'}}></div></div>
                </div>
                <div className="rounded-xl p-4 border border-purple-400/20" style={{ background: 'rgba(147,51,234,0.1)' }}>
                  <div className="text-sm text-purple-400 mb-2">{t('tradingExample.s2_aiTrue')}</div>
                  <div className="flex justify-between text-xs text-white mb-1"><span>{t('tradingExample.s2_yes')}</span><span className="font-bold">65%</span></div>
                  <div className="h-2 bg-white/8 rounded-full overflow-hidden"><div className="h-full rounded-full" style={{width: '65%', background: 'linear-gradient(90deg,#9333ea,#c084fc)'}}></div></div>
                </div>
                <div className="bg-white/[0.05] rounded-xl p-4 border border-white/8">
                  <div className="text-sm text-white/50 mb-1">{t('tradingExample.s2_probDiff')}</div>
                  <div className="text-3xl font-bold text-white">23%</div>
                </div>
              </div>
              <div className="border border-purple-400/25 rounded-xl p-3 flex items-center gap-2" style={{ background: 'rgba(147,51,234,0.15)' }}>
                <i className="ri-shield-check-fill text-purple-400 text-sm"></i>
                <span className="text-sm text-white font-medium">{t('tradingExample.s2_safe')}</span>
              </div>
            </div>
          </div>

          {/* Stage 3 */}
          <div className="premium-card premium-card-hover rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-purple-400/12 border border-purple-400/22 flex items-center justify-center">
                <i className="ri-flashlight-fill text-2xl text-purple-400"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-white font-heading">{t('tradingExample.s3_title')}</h3>
                <p className="text-sm text-purple-400">{t('tradingExample.s3_sub')}</p>
              </div>
            </div>
            <div className="space-y-4 mb-6">
              <div className="bg-white/[0.03] border border-purple-500/8 rounded-xl p-4">
                <div className="text-sm text-white/40 mb-2">{t('tradingExample.s3_exec')}</div>
                <div className="flex items-center gap-2 mb-2">
                  <i className="ri-arrow-right-circle-fill text-purple-400 text-sm"></i>
                  <span className="font-medium text-white">{t('tradingExample.s3_buyYes')}</span>
                </div>
                <div className="text-sm text-white/40">{t('tradingExample.s3_buyPrice')}: <span className="text-white font-medium">0.42 USDC</span></div>
              </div>
              <div className="bg-white/[0.03] border border-purple-500/8 rounded-xl p-4">
                <div className="text-sm text-white/40 mb-2">{t('tradingExample.s3_settlement')}</div>
                <div className="text-2xl font-bold text-white mb-1">1.00 USDC</div>
                <div className="text-sm text-purple-400">{t('tradingExample.s3_correct')}</div>
              </div>
              <div className="rounded-xl p-4 border border-purple-400/22" style={{ background: 'rgba(147,51,234,0.1)' }}>
                <div className="text-sm text-purple-400 mb-1">{t('tradingExample.s3_profit')}</div>
                <div className="text-4xl font-bold text-white mb-1 font-heading">3% – 10%</div>
                <div className="text-sm text-white/40">{t('tradingExample.s3_avg')}</div>
              </div>
            </div>
            <div className="bg-white/[0.03] border border-purple-400/12 rounded-xl p-3 flex items-center gap-2">
              <i className="ri-refresh-line text-purple-400 text-sm"></i>
              <span className="text-sm text-white/60 font-medium">{t('tradingExample.s3_recycle')}</span>
            </div>
          </div>
        </div>

        {/* Chart placeholder */}
        <div className="rounded-2xl overflow-hidden border border-purple-500/20 mb-10 md:mb-16" style={{ background: 'rgba(12,8,20,0.9)' }}>
          <div className="px-4 md:px-8 pt-6 md:pt-8 pb-4 border-b border-purple-500/15" style={{ background: 'rgba(168,85,247,0.06)' }}>
            <div className="flex items-center gap-3 mb-2">
              <div className="w-1.5 h-1.5 rounded-full bg-purple-400 animate-pulse"></div>
              <span className="text-purple-400 text-xs font-medium tracking-widest uppercase">{t('tradingExample.chart_live')}</span>
            </div>
            <h3 className="text-lg md:text-2xl font-bold text-white font-heading">{t('tradingExample.chart_title')}</h3>
            <p className="text-white/40 text-xs md:text-sm mt-1">{t('tradingExample.chart_sub')}</p>
            <div className="flex gap-3 mt-4">
              {[
                { labelKey: 'tradingExample.chart_curDev', val: '+27%', color: 'text-purple-300' },
                { labelKey: 'tradingExample.chart_signal', val: t('tradingExample.chart_signalVal'), color: 'text-emerald-300', pulse: true },
                { labelKey: 'tradingExample.chart_winRate', val: '72%', color: 'text-white' },
              ].map(s => (
                <div key={s.labelKey} className="flex-1 rounded-xl px-3 py-2.5 text-center border border-purple-500/80" style={{ background: 'rgba(255,255,255,0.04)' }}>
                  <div className="text-xs text-white/35 mb-1">{t(s.labelKey)}</div>
                  <div className={`text-lg md:text-xl font-bold ${s.color} flex items-center justify-center gap-1`}>
                    {s.pulse && <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 inline-block animate-pulse"></span>}
                    {s.val}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-3 border-t border-white/5">
            {[
              { labelKey: 'tradingExample.chart_bottom_implied', val: '42%', subKey: 'tradingExample.chart_bottom_implied_sub', color: 'text-white/50', highlight: false },
              { labelKey: 'tradingExample.chart_bottom_dev', val: '+23%', subKey: 'tradingExample.chart_bottom_dev_sub', color: 'text-purple-300', highlight: true },
              { labelKey: 'tradingExample.chart_bottom_ai', val: '65%', subKey: 'tradingExample.chart_bottom_ai_sub', color: 'text-white', highlight: false },
            ].map((s, i) => (
              <div key={i} className={`px-3 md:px-8 py-4 md:py-5 text-center ${i < 2 ? 'border-r border-white/5' : ''} ${s.highlight ? 'bg-purple-400/[0.06]' : ''}`}>
                <div className={`text-xs mb-1 ${s.highlight ? 'text-purple-400' : 'text-white/35'}`}>{t(s.labelKey)}</div>
                <div className={`text-xl md:text-3xl font-bold mb-1 ${s.color}`}>{s.val}</div>
                <div className="hidden md:block text-xs text-white/25">{t(s.subKey)}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Strategy Flow */}
        <div className="premium-card rounded-2xl p-4 md:p-8 mb-10 md:mb-16">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-5 md:mb-8 text-center font-heading">{t('tradingExample.flow_title')}</h3>
          <div className="hidden md:grid grid-cols-6 gap-4">
            {[
              { titleKey: 'tradingExample.flow0_title', descKey: 'tradingExample.flow0_desc', icon: 'ri-database-2-line' },
              null,
              { titleKey: 'tradingExample.flow1_title', descKey: 'tradingExample.flow1_desc', icon: 'ri-search-eye-line' },
              null,
              { titleKey: 'tradingExample.flow2_title', descKey: 'tradingExample.flow2_desc', icon: 'ri-time-line' },
              null,
            ].map((item, i) => item === null ? (
              <div key={i} className="flex items-center justify-center"><i className="ri-arrow-right-line text-2xl text-purple-400/30"></i></div>
            ) : (
              <div key={i} className="bg-white/[0.03] border border-purple-500/8 rounded-xl p-4 text-center hover:border-purple-400/18 transition-colors">
                <div className="w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-3" style={{ background: 'linear-gradient(135deg,#9333ea,#7c3aed)' }}>
                  <i className={`${item.icon} text-lg text-white`}></i>
                </div>
                <div className="text-xs font-medium text-white mb-1">{t(item.titleKey)}</div>
                <div className="text-xs text-white/35">{t(item.descKey)}</div>
              </div>
            ))}
          </div>
          <div className="hidden md:flex justify-center my-6"><i className="ri-arrow-down-line text-2xl text-purple-400/30"></i></div>
          <div className="hidden md:grid md:grid-cols-4 gap-4">
            {[
              { titleKey: 'tradingExample.flow3_title', descKey: 'tradingExample.flow3_desc', icon: 'ri-shield-check-line' },
              { titleKey: 'tradingExample.flow4_title', descKey: 'tradingExample.flow4_desc', icon: 'ri-flashlight-fill' },
              { titleKey: 'tradingExample.flow5_title', descKey: 'tradingExample.flow5_desc', icon: 'ri-money-dollar-circle-line' },
              { titleKey: 'tradingExample.flow6_title', descKey: 'tradingExample.flow6_desc', icon: 'ri-refresh-line' },
            ].map(item => (
              <div key={item.titleKey} className="bg-white/[0.03] border border-purple-500/8 rounded-xl p-4 text-center hover:border-purple-400/18 transition-colors">
                <div className="w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-3" style={{ background: 'linear-gradient(135deg,#9333ea,#7c3aed)' }}>
                  <i className={`${item.icon} text-lg text-white`}></i>
                </div>
                <div className="text-xs font-medium text-white mb-1">{t(item.titleKey)}</div>
                <div className="text-xs text-white/35">{t(item.descKey)}</div>
              </div>
            ))}
          </div>
          {/* Mobile */}
          <div className="md:hidden grid grid-cols-2 gap-3">
            {['flow0','flow1','flow2','flow3','flow4','flow5','flow6'].map(f => (
              <div key={f} className="bg-white/[0.03] border border-purple-500/8 rounded-xl p-3 text-center">
                <div className="text-xs font-medium text-white mb-0.5">{t(`tradingExample.${f}_title`)}</div>
                <div className="text-xs text-white/35">{t(`tradingExample.${f}_desc`)}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Risk Control */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {[
            { icon: 'ri-shield-line', titleKey: 'tradingExample.risk0_title', items: ['tradingExample.risk0_i0','tradingExample.risk0_i1','tradingExample.risk0_i2'] },
            { icon: 'ri-time-line', titleKey: 'tradingExample.risk1_title', items: ['tradingExample.risk1_i0','tradingExample.risk1_i1','tradingExample.risk1_i2'] },
            { icon: 'ri-line-chart-line', titleKey: 'tradingExample.risk2_title', items: ['tradingExample.risk2_i0','tradingExample.risk2_i1','tradingExample.risk2_i2'] },
          ].map(card => (
            <div key={card.titleKey} className="premium-card premium-card-hover rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <i className={`${card.icon} text-xl text-purple-400`}></i>
                <h4 className="text-lg font-bold text-white font-heading">{t(card.titleKey)}</h4>
              </div>
              <ul className="space-y-2 text-sm text-white/45">
                {card.items.map(key => (
                  <li key={key} className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-purple-400/60 mt-0.5 text-xs flex-shrink-0"></i>
                    <span>{t(key)}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
